export default {
    sounds: {
        gong: 'Gong',
        chimes: 'Dzwonki',
        marimba: 'Marimba',
        drop: 'Kropla',
        pulse: 'Puls',
        beep: 'Bipnięcie',
        alarm_1: 'Alarm 1',
        alarm_2: 'Alarm 2',
        gentle: 'Łagodne',
        loud: 'Wyraźne',
        test: 'Testuj',
        search: 'Szukaj dźwięku…',
    },
    pomodoro: {
        start: 'Start',
        pause: 'Pauza',
        resume: 'Wznów',
        silence: 'Wycisz',
        paused: 'Wstrzymano',
        ready: 'Gotowy',
        skipTo: 'Pomiń — przejdź do: {phase}',
        nextPhase: 'Dalej: {phase}',
        fullscreen: {
            workDone: 'Pomodoro ukończone!',
            breakDone: 'Koniec przerwy!',
            focus: 'Skupienie',
            rest: 'Odpoczynek',
            exit: 'Wyjdź z pełnego ekranu (Esc)',
            autoStartOn: 'Auto-start włączony — po sygnale rusza: {phase}',
            escHint: 'Esc wychodzi z pełnego ekranu',
        },
        dialog: {
            today: 'Dziś {count} pomodoro · {minutes} min skupienia',
            workDone: 'Pomodoro ukończone',
            breakDone: 'Koniec przerwy',
            paused: 'Wstrzymane',
            ready: 'Gotowe do startu',
            cycle: 'Cykl: {done} / {total}',
            overtime: '+{time} po czasie · dalej: {phase}',
            goTo: 'Przejdź do: {phase}',
            resetPhase: 'Wyzeruj fazę',
            focusMode: 'Tryb skupienia (pełny ekran)',
            task: 'Nad czym pracujesz',
            taskPlaceholder: 'np. raport na piątek',
            preset: 'Zestaw',
            presetTitle: '{work} / {short} / {long} min, długa co {every}',
            short: 'Krótka',
            long: 'Długa',
            minutesLabel: '{label} min',
            longEvery: 'Długa co',
            autoStart: 'Kolejna faza startuje sama',
            workEndSound: 'Koniec pracy',
            breakEndSound: 'Koniec przerwy',
            restoreDefaults: 'Przywróć domyślne',
            restoreTitle: 'Przywrócić domyślne ustawienia?',
            restore: 'Przywróć',
            restoreMessage: 'Wróci 25 / 5 / 15 min, długa przerwa co 4, bez auto-startu. Nazwa zadania i cykl się wyzerują — statystyki zostają.',
        },
        presets: {
            classic: 'Klasyczne',
            short: 'Krótkie',
            deep: 'Głębokie',
            sprint: 'Sprint',
        },
        phases: {
            work: 'Praca',
            shortBreak: 'Krótka przerwa',
            longBreak: 'Długa przerwa',
        },
        weekdays: {
            sun: 'nd',
            mon: 'pn',
            tue: 'wt',
            wed: 'śr',
            thu: 'cz',
            fri: 'pt',
            sat: 'sb',
        },
    },
    timers: {
        title: 'Minutniki',
        ringing: 'Jeden dzwoni — zatrzymaj, żeby ucichł. | {n} dzwonią — zatrzymaj, żeby ucichł. | {n} dzwonią — zatrzymaj, żeby ucichł.',
        counting: 'Jeden odlicza — okno można zamknąć, czas leci dalej. | {n} odliczają — okno można zamknąć, czas leci dalej. | {n} odliczają — okno można zamknąć, czas leci dalej.',
        intro: 'Trzy niezależne odliczania. Chodzą dalej po zamknięciu okna.',
        heading: 'MINUTNIK {n}',
        overtime: '+{time} po czasie',
        status: {
            finished: 'Czas minął',
            running: 'Odliczanie',
            paused: 'Wstrzymany',
        },
        stop: 'Zatrzymaj',
        reset: 'Reset',
        restart: 'Ponów',
        name: 'Nazwa',
        namePlaceholder: 'np. makaron',
        quick: 'Szybki wybór',
        minutes: 'Minuty',
        seconds: 'Sekundy',
        sound: 'Dźwięk',
    },
};
